{
  "labels": {
    "paste": "Beillesztés",
    "pasteAsPlaintext": "Beillesztés formázatlan szövegként",
    "pasteCharts": "Grafikon beillesztése",
    "selectAll": "Összes kijelölése",
    "multiSelect": "Elem hozzáadása a kijelöléshez",
    "moveCanvas": "Vászon mozgatása",
    "cut": "Kivágás",
    "copy": "Másolás",
    "copyAsPng": "Vágólapra másolás mint PNG",
    "copyAsSvg": "Vágólapra másolás mint SVG",
    "copyText": "Vágólapra másolás szövegként",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Előrébb hozás",
    "sendToBack": "Hátraküldés",
    "bringToFront": "Előrehozás",
    "sendBackward": "Hátrébb küldés",
    "delete": "Törlés",
    "copyStyles": "Stílus másolása",
    "pasteStyles": "Stílus beillesztése",
    "stroke": "Körvonal",
    "background": "Háttér",
    "fill": "Kitöltés",
    "strokeWidth": "Körvonal vastagsága",
    "strokeStyle": "Körvonal stílusa",
    "strokeStyle_solid": "Kitöltött",
    "strokeStyle_dashed": "Szaggatott",
    "strokeStyle_dotted": "Pontozott",
    "sloppiness": "Stílus",
    "opacity": "Áttetszőség",
    "textAlign": "Szöveg igazítása",
    "edges": "Szélek",
    "sharp": "Éles",
    "round": "Kerek",
    "arrowheads": "Nyílhegyek",
    "arrowhead_none": "Nincs",
    "arrowhead_arrow": "Nyíl",
    "arrowhead_bar": "Oszlop",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Háromszög",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Betűméret",
    "fontFamily": "Betűkészlet család",
    "addWatermark": "Add hozzá, hogy \"Excalidraw-val készült\"",
    "handDrawn": "Kézzel rajzolt",
    "normal": "Normál",
    "code": "Kód",
    "small": "Kicsi",
    "medium": "Közepes",
    "large": "Nagy",
    "veryLarge": "Nagyon nagy",
    "solid": "Kitöltött",
    "hachure": "Vonalkázott",
    "zigzag": "Cikkcakk",
    "crossHatch": "Keresztcsíkozott",
    "thin": "Vékony",
    "bold": "Félkövér",
    "left": "Bal",
    "center": "Közép",
    "right": "Jobb",
    "extraBold": "Extra Félkövér",
    "architect": "Tervezői",
    "artist": "Művészi",
    "cartoonist": "Karikatúrás",
    "fileTitle": "Fájlnév",
    "colorPicker": "Színválasztó",
    "canvasColors": "Rajzvászonon használt",
    "canvasBackground": "Vászon háttérszíne",
    "drawingCanvas": "Rajzvászon",
    "layers": "Rétegek",
    "actions": "Műveletek",
    "language": "Nyelv",
    "liveCollaboration": "Élő együttműködés...",
    "duplicateSelection": "Duplikálás",
    "untitled": "Névtelen",
    "name": "Név",
    "yourName": "Neved",
    "madeWithExcalidraw": "Excalidraw-val készült",
    "group": "Csoportosítás",
    "ungroup": "Csoportbontás",
    "collaborators": "Közreműködők",
    "showGrid": "Rács megjelenítése",
    "addToLibrary": "Hozzáadás a könyvtárhoz",
    "removeFromLibrary": "Eltávólítás a könyvtárból",
    "libraryLoadingMessage": "Könyvtár betöltése…",
    "libraries": "Könyvtárak böngészése",
    "loadingScene": "Jelenet betöltése…",
    "align": "Igazítás",
    "alignTop": "Felülre igazítás",
    "alignBottom": "Alulra igazítás",
    "alignLeft": "Balra igazítás",
    "alignRight": "Jobbra igazítás",
    "centerVertically": "Függőlegesen középre igazított",
    "centerHorizontally": "Vízszintesen középre igazított",
    "distributeHorizontally": "Vízszintes elosztás",
    "distributeVertically": "Függőleges elosztás",
    "flipHorizontal": "Vízszintes tükrözés",
    "flipVertical": "Függőleges tükrözés",
    "viewMode": "Nézet",
    "share": "Megosztás",
    "showStroke": "Körvonal színválasztó megjelenítése",
    "showBackground": "Háttérszín-választó megjelenítése",
    "toggleTheme": "Téma váltása",
    "personalLib": "Személyes könyvtár",
    "excalidrawLib": "Excalidraw könyvtár",
    "decreaseFontSize": "Betűméret csökkentése",
    "increaseFontSize": "Betűméret növelése",
    "unbindText": "Szövegkötés feloldása",
    "bindText": "",
    "createContainerFromText": "Szöveg bekeretezése",
    "link": {
      "edit": "Hivatkozás szerkesztése",
      "editEmbed": "Link szerkesztése / beágyazása",
      "create": "Hivatkozás létrehozása",
      "createEmbed": "Link létrehozása / beágyazása",
      "label": "Hivatkozás",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "",
      "exit": ""
    },
    "elementLock": {
      "lock": "Rögzítés",
      "unlock": "Rögzítés feloldása",
      "lockAll": "Összes rögzítése",
      "unlockAll": "Összes feloldása"
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": ""
  },
  "buttons": {
    "clearReset": "Vászon törlése",
    "exportJSON": "Exportálás fájlba",
    "exportImage": "Kép exportálása...",
    "export": "Mentés másként...",
    "copyToClipboard": "Vágólapra másolás",
    "save": "Mentés az aktuális fájlba",
    "saveAs": "Mentés másként",
    "load": "Megnyitás",
    "getShareableLink": "Megosztható link létrehozása",
    "close": "Bezárás",
    "selectLanguage": "Nyelv kiválasztása",
    "scrollBackToContent": "Visszagörgetés a tartalomhoz",
    "zoomIn": "Nagyítás",
    "zoomOut": "Kicsinyítés",
    "resetZoom": "Nagyítás alaphelyzetbe",
    "menu": "Menü",
    "done": "Kész",
    "edit": "Szerkesztés",
    "undo": "Vissza",
    "redo": "Újra",
    "resetLibrary": "Könyvtár alaphelyzetbe állítása",
    "createNewRoom": "Új szoba létrehozása",
    "fullScreen": "Teljes képernyő",
    "darkMode": "Sötét mód",
    "lightMode": "Világos mód",
    "zenMode": "Letisztult mód",
    "objectsSnapMode": "",
    "exitZenMode": "Kilépés a letisztult módból",
    "cancel": "Mégsem",
    "clear": "Kiűrítés",
    "remove": "Eltávolítás",
    "embed": "",
    "publishLibrary": "Közzététel",
    "submit": "Elküldés",
    "confirm": "Megerősítés",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Ez a művelet törli a vászont. Biztos benne?",
    "couldNotCreateShareableLink": "Nem sikerült megosztható linket létrehozni.",
    "couldNotCreateShareableLinkTooBig": "Nem sikerült megosztható linket látrehozni: túl nagy a jelenet",
    "couldNotLoadInvalidFile": "Nem sikerült betölteni a helytelen fájlt",
    "importBackendFailed": "Nem sikerült betölteni a szerverről.",
    "cannotExportEmptyCanvas": "Üres vászont nem lehet exportálni.",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "Nem sikerült visszafejteni a titkosított adatot.",
    "uploadedSecurly": "A feltöltést végpontok közötti titkosítással biztosítottuk, ami azt jelenti, hogy egy harmadik fél nem tudja megnézni a tartalmát, beleértve az Excalidraw szervereit is.",
    "loadSceneOverridePrompt": "A betöltött külső rajz felül fogja írnia meglévőt. Szeretnéd folytatni?",
    "collabStopOverridePrompt": "A munkamenet leállítása felül fogja írni az előzőleg helyben tárolt rajzot. Biztosan ezt akarod?\n(Ha meg akarod tartani a helyben tárolt rajzot, egyszerűen csak zárd be a böngésző fület)",
    "errorAddingToLibrary": "A tétel nem addható hozzá a könyvtárhoz",
    "errorRemovingFromLibrary": "A tétel nem távolítható el a könyvtárból",
    "confirmAddLibrary": "Ez a művelet {{numShapes}} formát fog hozzáadni a könyvtáradhoz. Biztos vagy benne?",
    "imageDoesNotContainScene": "Úgy tűnik, hogy ez a kép nem tartalmaz jelenetadatokat. Engedélyezted a jelenetbeágyazást az exportálás során?",
    "cannotRestoreFromImage": "A jelenet visszaállítása nem sikerült ebből a kép fájlból",
    "invalidSceneUrl": "Nem sikerült importálni a jelenetet a megadott URL-ről. Rossz formátumú, vagy nem tartalmaz érvényes Excalidraw JSON-adatokat.",
    "resetLibrary": "Ezzel törlöd a könyvtárát. biztos vagy ebben?",
    "removeItemsFromsLibrary": "{{count}} elemet törölsz a könyvtárból?",
    "invalidEncryptionKey": "A titkosítási kulcsnak 22 karakterből kell állnia. Az élő együttműködés le van tiltva.",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "Nem támogatott fájltípus.",
    "imageInsertError": "Nem sikerült beszúrni a képet. Próbáld újra később...",
    "fileTooBig": "A fájl túl nagy. A megengedett maximális méret {{maxSize}}.",
    "svgImageInsertError": "Nem sikerült beszúrni az SVG-képet. Az SVG szintaktika érvénytelennek tűnik.",
    "failedToFetchImage": "",
    "invalidSVGString": "Érvénytelen SVG.",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Kijelölés",
    "image": "Kép beszúrása",
    "rectangle": "Téglalap",
    "diamond": "Rombusz",
    "ellipse": "Ellipszis",
    "arrow": "Nyíl",
    "line": "Vonal",
    "freedraw": "Rajzolás",
    "text": "Szöveg",
    "library": "Könyvtár",
    "lock": "Rajzolás után az aktív eszközt tartsa kijelölve",
    "penMode": "",
    "link": "Hivatkozás hozzáadása/frissítése a kiválasztott alakzathoz",
    "eraser": "Radír",
    "frame": "",
    "magicframe": "",
    "embeddable": "Weblap beágyazása",
    "laser": "Lézermutató",
    "hand": "",
    "extraTools": "További eszközök",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Vászon műveletek",
    "selectedShapeActions": "Kijelölt forma műveletei",
    "shapes": "Alakzatok"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "Kattintással görbe, az eger húzásával pedig egyenes nyilat rajzolhatsz",
    "freeDraw": "Kattints és húzd, majd engedd el, amikor végeztél",
    "text": "Tipp: A kijelölés eszközzel a dupla kattintás új szöveget hoz létre",
    "embeddable": "",
    "text_selected": "Kattints duplán, vagy nyomj entert a szöveg szerkesztéséhez",
    "text_editing": "Nyomjd meg az Escape vagy a Ctrl/Cmd+ENTER billentyűkombinációt a szerkesztés befejezéséhez",
    "linearElementMulti": "Kattints a következő ív pozíciójára, vagy fejezd be a nyilat az Escape vagy Enter megnyomásával",
    "lockAngle": "A SHIFT billentyű lenyomva tartásával korlátozhatja forgatás szögét",
    "resize": "A SHIFT billentyű lenyomva tartásával az átméretezés megtartja az arányokat,\naz ALT lenyomva tartásával pedig a középpont egy helyben marad",
    "resizeImage": "A SHIFT billentyű lenyomva tartásával szabadon átméretezheted,\ntartsd lenyomva az ALT billentyűt a középről való átméretezéshez",
    "rotate": "A SHIFT billentyű lenyomva tartásával korlátozhatja a szögek illesztését",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "Nyomd meg a Törlés gombot a pont(ok) eltávolításához,\nA Ctrl/Cmd+D a többszörözéshez, vagy húzással mozgathatja",
    "lineEditor_nothingSelected": "Válaszd ki a szerkeszteni kívánt pontot (több kijelöléséhez tartsd lenyomva a SHIFT billentyűt),\nvagy Alt, és kattintson az új pontok hozzáadásához",
    "placeImage": "Kattints a kép elhelyezéséhez, vagy kattints és méretezd manuálisan",
    "publishLibrary": "Tedd közzé saját könyvtáradat",
    "bindTextToElement": "Nyomd meg az Entert szöveg hozzáadáshoz",
    "deepBoxSelect": "Tartsd lenyomva a Ctrl/Cmd billentyűt a mély kijelöléshez és a húzás megakadályozásához",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Előnézet nem jeleníthető meg",
    "canvasTooBig": "A vászon talán túl nagy.",
    "canvasTooBigTip": "Tipp: próbáld meg a legtávolabbi elemeket közelebb hozni egy máshoz."
  },
  "errorSplash": {
    "headingMain": "Hiba történt. Próbáld <button>újratölteni az oldalt.</button>",
    "clearCanvasMessage": "Ha az újratöltés nem működik, próbáld <button>letörölni a vászont.</button>",
    "clearCanvasCaveat": " Ezzel az eddigi munka elveszik ",
    "trackedToSentry": "A hibakód azonosítóval {{eventId}} nyomon van követve a rendszerünkben.",
    "openIssueMessage": "Vigyáztunk arra, hogy a jelenthez tartozó információ ne jelenjen meg a hibaüzenetben. Ha a jeleneted nem bizalmas, kérjük add hozzá a <button>hibakövető rendszerünkhöz.</button> Kérjük, másolja be az alábbi információkat a GitHub problémába.",
    "sceneContent": "Jelenet tartalma:"
  },
  "roomDialog": {
    "desc_intro": "Meghívhat embereket a jelenlegi jelenetbe, hogy együttműködjenek önnel.",
    "desc_privacy": "Ne aggódj, a munkamenet végpontok közötti titkosítást használ, tehát bármit rajzolsz, privát marad. Még a szerverünkről se lehet belenézni.",
    "button_startSession": "Munkamenet indítása",
    "button_stopSession": "Munkamenet leállítása",
    "desc_inProgressIntro": "Az élő együttműködési munkamenet folyamatban van.",
    "desc_shareLink": "Ossza meg ezt a linket bárkivel, akivel együtt szeretne működni:",
    "desc_exitSession": "Az munkamenet leállítása kilépteti önt a szobából, de folytathatja a munkát a saját gépén. Vegye figyelembe, hogy ez nem érinti más emberek munkáját és ők továbbra is együttműködhetnek a saját változatukon.",
    "shareTitle": "Csatlakozás egy élő együttműködési munkamenethez az Excalidraw-ban"
  },
  "errorDialog": {
    "title": "Hiba"
  },
  "exportDialog": {
    "disk_title": "Mentés lemezre",
    "disk_details": "Exportálja a jelenetadatokat egy fájlba, amelyből később importálhatja.",
    "disk_button": "Mentés fájlba",
    "link_title": "Megosztható hivatkozás",
    "link_details": "Exportálás csak olvasható hivatkozásként.",
    "link_button": "Exportálás hivatkozásba",
    "excalidrawplus_description": "Mentse el a jelenetet az Excalidraw+ munkaterületére.",
    "excalidrawplus_button": "Exportálás",
    "excalidrawplus_exportError": "Jelenleg nem lehet exportálni az Excalidraw+-ba..."
  },
  "helpDialog": {
    "blog": "Olvasd a blogunkat",
    "click": "kattintás",
    "deepSelect": "Mély kijelölés",
    "deepBoxSelect": "Mély kijelölés a dobozon belül, és a húzás megakadályozása",
    "curvedArrow": "Ívelt nyíl",
    "curvedLine": "Ívelt vonal",
    "documentation": "Dokumentáció",
    "doubleClick": "dupla kattintás",
    "drag": "vonszolás",
    "editor": "Szerkesztő",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Hibát találtál? Küld be",
    "howto": "Kövesd az útmutatóinkat",
    "or": "vagy",
    "preventBinding": "A nyíl ne ragadjon",
    "tools": "",
    "shortcuts": "Gyorsbillentyűk",
    "textFinish": "Szerkesztés befejezése (szöveg)",
    "textNewLine": "Új sor hozzáadása (szöveg)",
    "title": "Segítség",
    "view": "Nézet",
    "zoomToFit": "Az összes elem látótérbe hozása",
    "zoomToSelection": "Kijelölésre nagyítás",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": "Rajzvászon alaphelyzetbe"
  },
  "publishDialog": {
    "title": "Könyvtár közzététele",
    "itemName": "Tétel neve",
    "authorName": "Szerző neve",
    "githubUsername": "GitHub felhasználónév",
    "twitterUsername": "Twitter felhasználónév",
    "libraryName": "Könyvtár neve",
    "libraryDesc": "Könyvtár leírása",
    "website": "Weboldal",
    "placeholder": {
      "authorName": "Neved vagy felhasználóneved",
      "libraryName": "A könyvtárad neve",
      "libraryDesc": "A könyvtárad használatát segítő leírás",
      "githubHandle": "GitHub-handle(opcionális), így szerkesztheted a könyvtárat, miután elküldted ellenőrzésre",
      "twitterHandle": "Twitter-felhasználónév (opcionális), így tudjuk, kinek kell jóváírni a Twitteren keresztüli reklámozást",
      "website": "Hivatkozás személyes webhelyedre vagy máshová (nem kötelező)"
    },
    "errors": {
      "required": "Kötelező",
      "website": "Adj meg egy érvényes URL-t"
    },
    "noteDescription": "Küld be könyvtáradat, hogy bekerüljön a <link>nyilvános könyvtár tárolóba</link>hogy mások is felhasználhassák a rajzaikban.",
    "noteGuidelines": "A könyvtárat először manuálisan kell jóváhagyni. Kérjük, olvassa el a <link>segédletet</link> benyújtása előtt. Szüksége lesz egy GitHub-fiókra a kommunikációhoz és a módosításokhoz, ha kérik, de ez nem feltétlenül szükséges.",
    "noteLicense": "A beküldéssel elfogadja, hogy a könyvtár a következő alatt kerül közzétételre <link>MIT Licensz </link>ami röviden azt jelenti, hogy bárki korlátozás nélkül használhatja őket.",
    "noteItems": "Minden könyvtárelemnek saját nevével kell rendelkeznie, hogy szűrhető legyen. A következő könyvtári tételek kerülnek bele:",
    "atleastOneLibItem": "A kezdéshez válassz ki legalább egy könyvtári elemet",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "A könyvtár beküldve",
    "content": "Köszönjük {{authorName}}. Könyvtáradat elküldtük felülvizsgálatra. Nyomon követheted az állapotot<link>itt</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Könyvtár alaphelyzetbe állítása",
    "removeItemsFromLib": "A kiválasztott elemek eltávolítása a könyvtárból"
  },
  "imageExportDialog": {
    "header": "Kép exportálása",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Vágólapra másolás"
    }
  },
  "encrypted": {
    "tooltip": "A rajzaidat végpontok közötti titkosítással tároljuk, tehát az Excalidraw szervereiről se tud más belenézni.",
    "link": "Blogbejegyzés a végpontok közötti titkosításról az Excalidraw-ban"
  },
  "stats": {
    "angle": "Szög",
    "element": "Elem",
    "elements": "Elemek",
    "height": "Magasság",
    "scene": "Jelenet",
    "selected": "Kijelölt",
    "storage": "Tárhely",
    "title": "Statisztikák",
    "total": "Összesen",
    "version": "Verzió",
    "versionCopy": "Kattints a másoláshoz",
    "versionNotAvailable": "A verzió nem elérhető",
    "width": "Szélesség"
  },
  "toast": {
    "addedToLibrary": "Könyvtárhoz adva",
    "copyStyles": "Másolt stílusok.",
    "copyToClipboard": "Vágólapra másolva.",
    "copyToClipboardAsPng": "Az {{exportSelection}} PNG formátumban a vágólapra másolva \n({{exportColorScheme}})",
    "fileSaved": "Fájl elmentve.",
    "fileSavedToFilename": "Mentve mint {filename}",
    "canvas": "rajzvászon",
    "selection": "kijelölés",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Átlátszó",
    "black": "Fekete",
    "white": "Fehér",
    "red": "Piros",
    "pink": "Rózsaszín",
    "grape": "",
    "violet": "Ibolya",
    "gray": "Szürke",
    "blue": "Kék",
    "cyan": "Cián",
    "teal": "Kékes-zöld",
    "green": "Zöld",
    "yellow": "Sárga",
    "orange": "Narancssárga",
    "bronze": "Bronz"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "Hexadecimális kód",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportálás képként",
        "button": "Exportálás képként",
        "description": ""
      },
      "saveToDisk": {
        "title": "Mentés a lemezre",
        "button": "Mentés a lemezre",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Betöltés fájlból",
        "button": "Betöltés fájlból",
        "description": ""
      },
      "shareableLink": {
        "title": "Feltöltás linkből",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
